import ContextConnectButton from '@/components/ContextCard/ContextConnectButton'
import styles from '@/components/ContextCard/contextCardMedia.module.scss'

export default function ArtifactCardInner({
  Icon, title, status, kindText, canPreview, onPreview,
}) {
  return (
    <div className={styles.media}>
      <span className={`${styles.glyph} ${styles.doc}`} aria-hidden>
        <Icon fontSize={20} />
      </span>
      <div className={styles.copy}>
        <div className={styles.title}>{title}</div>
        <div className={styles.meta}>{kindText} · {status.label}</div>
      </div>
      {onPreview ? (
        <ContextConnectButton
          type="button"
          hideIcon
          className={styles.open}
          onClick={onPreview}
          disabled={!canPreview}
        >
          Open
        </ContextConnectButton>
      ) : null}
    </div>
  )
}
